import styled from 'styled-components'

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #d3d3d3;

    h2 {
        font-family: 'Poppins';
        font-size: 22px;
        font-weight: 400;
    }

    p {
        font-family: 'Poppins';
        font-size: 14px;
        font-weight: 400;
    }
`

export const DocumentContainer = styled.div`
    margin-top: 20px;
    border-radius: 10px;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    padding: 20px;
`

export const TableContainer = styled.div`
    overflow: auto;
`

export const DocumentTable = styled.table`
    padding: 10px;
    table-layout: fixed;
    /* border: 1px solid #333; */
    border-collapse: collapse;
    width: 100%;
    min-width: 1000px;
    thead {
        padding: 0 10px;
        border-bottom: 1px solid #d3d3d3;
        /* border-top: 1px solid #d3d3d3; */

        th {
            color: #a8a39d;
            font-weight: 400;
            font-family: 'Poppins';
            font-size: 14px;
            padding: 10px 0;
        }

        /* th:first-child {
            width: 50%;
        } */

        th:nth-child(1) {
            width: 60%;
        }

        th:nth-child(2) {
            width: 20%;
        }

        th:nth-child(3) {
            width: 20%;
        }

        /* th:last-child {
            width: 10%;
        } */
    }

    tbody {
        tr:not(tr:last-child) {
            border-bottom: 1px solid #d3d3d3;
        }

        tr > td {
            color: #333;
            font-family: 'Inter';
            font-weight: 400;
            font-size: 14px;
        }

        /* td:first-child {
            width: 50px;
            padding: 0 10px 0px 14px;
        } */
        tr {
            position: relative;
            cursor: pointer;

            &:hover {
                background: rgba(37, 99, 235, 0.03);
            }
        }
    }

    td,
    th {
        padding: 15px 0;
        text-align: left;
    }
`
